<template lang="pug">
#not-found(v-cloak)
  #pc.d-flex.align-items-center.justify-content-center(v-if="appmode == 'pc'")
    .box.box-margin
      .box-body.p-4
        p.message.mb-4 お探しのページが見つかりません
        p あなたがアクセスしようとしたページは削除されたかURLが変更されているため、見つけることができません。
        button.btn.btn-default-style.logout-btn(@click="logout()") ログイン画面へ

  #mobile(v-if="appmode == 'mobile'")
    .p-4
      p.title.mb-4 お探しのページが見つかりません
      p あなたがアクセスしようとしたページは削除されたかURLが変更されているため、見つけることができません。
      button.btn.btn-default-style.logout-btn(@click="logout()") ログイン画面へ
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";
import { userStore } from "@/store/store";
import { Url } from "@/commons/constants/Url";

/**
 * ### 404 NotFound画面コンポーネント
 */
@Component
export default class NotFound extends Vue {
  /** アプリモード。storeのgetterから値を取得する */
  @Getter("appMode") appmode!: string;

  /**
   * ### ログイン画面へ遷移する
   */
  public logout(): void {
    userStore.logout();
    this.$router.push(Url.Root);

    return;
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/pc/_colors.scss";
@import "../../styles/pc/_mixin.scss";

#not-found {
  word-break: break-all;

  #pc {
    height: 100vh;
    width: 100vw;
    background-color: $bg-gray !important;

    .box {
      width: 520px;
      margin-left: auto;
      margin-right: auto;
      .box-body {
        .message {
          font-size: 1.55rem;
        }
        .logout-btn {
          min-width: 160px;
        }
      }
    }
  }

  #mobile {
    background-color: $bg-default !important;

    .title {
      color: rgba(51, 51, 51, 1);
      font-size: 1.4rem;
      font-weight: bold;
    }
  }
}
</style>
